import { useTranslation } from "react-i18next";
import { statusBadgePalette, type OrderStatus } from "../api/orders";

const STATUS_KEY: Record<OrderStatus, string> = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
  IN_REVIEW: "inReview",
  APPROVED: "approved",
  REJECTED: "rejected",
  SHIPPED: "shipped",
  INVOICED: "invoiced",
  CANCELLED: "cancelled",
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation();
  const c = statusBadgePalette(status);
  const label = t(`orders.status.${STATUS_KEY[status]}`, { defaultValue: status });
  return (
    <span
      style={{
        background: c.bg,
        color: c.fg,
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}
